import { ASC_SORT_DIRECTION, NO_SORT_DIRECTION, SortDirection } from '@shared/ui/data-table';
import { useEffect, useState } from 'react';

export const useSorting = <T extends object>(rows: T[]) => {
  const [sortDirection] = useState<SortDirection>(NO_SORT_DIRECTION);
  const [displayedRows, setDisplayedRows] = useState<T[]>(rows);

  useEffect(() => {
    setDisplayedRows(rows);
  }, [rows]);

  const sortDisplayedRows = (sortDirectionCurrent: SortDirection, sortColumnCurrent: Extract<keyof T, string>) => {
    if (sortDirectionCurrent === NO_SORT_DIRECTION) {
      setDisplayedRows(rows);
      return;
    }

    const sortedRows = [...rows].sort((a, b) => {
      if (a[sortColumnCurrent] < b[sortColumnCurrent]) return sortDirectionCurrent === ASC_SORT_DIRECTION ? -1 : 1;
      if (a[sortColumnCurrent] > b[sortColumnCurrent]) return sortDirectionCurrent === ASC_SORT_DIRECTION ? 1 : -1;
      return 0;
    });

    setDisplayedRows(sortedRows);
  };

  return { displayedRows, sortDirection, sortDisplayedRows };
};
